module.exports = __webpack_public_path__ + "img/news_1.e365375d.png";